import { DEFAULT_PARTITION_COUNT, ensureValidStreamPartitionCount } from '@streamr/utils';
import { StreamrClientError } from './StreamrClientError';
export const parseMetadata = (metadata) => {
    try {
        return JSON.parse(metadata);
    }
    catch (_ignored) {
        return {};
    }
};
export const getPartitionCount = (metadata) => {
    const metadataValue = metadata.partitions;
    if (metadataValue !== undefined) {
        try {
            ensureValidStreamPartitionCount(metadataValue);
        }
        catch {
            throw new StreamrClientError(`Invalid partition count: ${metadataValue}`, 'INVALID_STREAM_METADATA');
        }
    }
    return metadataValue ?? DEFAULT_PARTITION_COUNT;
};
